'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerWithLeftHandNavigationBelowBannerContents = renderWithRef('BannerWithLeftHandNavigationBelowBannerContents', null, (t, a)=>{
    let { children: r } = t;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: [
            'swan-banner-with-left-hand-navigation-below-banner'
        ],
        props: t,
        children: r
    });
});

export { BannerWithLeftHandNavigationBelowBannerContents };
